import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Menu from '../../components/menus/Menu/Menu'
import TemplateForm from '../../components/forms/TemplateForm/TemplateForm'
import { getTemplate } from '../../actions/template'
import { useTitle } from '../../helpers/use_title.helper'
import './TemplateFormPage.css'

function TemplateFormPage () {
  const { id } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const client = useSelector((state) => state.client)
  const user = useSelector((state) => state.user)

  const isEditing = !!id
  useTitle(isEditing ? 'Ki | Editar template' : 'Ki | Nuevo template')

  const [template, setTemplate] = useState(location.state?.template ?? null)
  const [loadingTemplate, setLoadingTemplate] = useState(isEditing && !location.state?.template)

  useEffect(() => {
    if (isEditing && !location.state?.template) fetchTemplate()
  }, [id])

  async function fetchTemplate () {
    setLoadingTemplate(true)
    try {
      const { data } = await getTemplate(client._id, id)
      setTemplate(data)
    } catch {
      goBack()
    } finally {
      setLoadingTemplate(false)
    }
  }

  function goBack () {
    navigate('/profile', { state: { tab: 'templates' } })
  }

  const wabaLabel = client?.whatsapp
    ? `${client.name} | ${client.whatsapp.displayPhoneNumber}`
    : null

  return (
    <div className='template-form-page'>
      <div className='main-container'>
        <div className='row main-container-row'>

          <Menu selectedBtn='templates' handleClick={() => goBack()} user={user} />

          <div className='col-md-9 information'>
            <div className='tfp-content'>

              {/* Page header — back button + title + WABA badge */}
              <div className='tfp-header'>
                <div className='tfp-header-left'>
                  <button className='tfp-back-btn' onClick={goBack}>← Templates</button>
                  <h4>{isEditing ? 'Editar template' : 'Crear template'}</h4>
                </div>
                {wabaLabel && (
                  <div className='tfp-waba-badge'>
                    <span className='tfp-waba-dot' />
                    {wabaLabel}
                  </div>
                )}
              </div>

              {loadingTemplate
                ? <p style={{ color: '#aaa', textAlign: 'center', padding: 60 }}>Cargando...</p>
                : (
                  <TemplateForm
                    templateToEdit={isEditing ? template : null}
                    onSaved={goBack}
                    onCancel={goBack}
                  />
                  )}
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default TemplateFormPage
